import React, { Component, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Table } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import H3Text from '@Uilib/h3Text';
import InvoiceActions from '@Actions/invoiceActions';
import Helpers from '@Apis/helpers';
import { toISTDate } from '@Apis/constants';
import './style.scss';
import HideValue from '../../../../Common/RestrictedAccess/HideValue';
/**
 *
 */
class CustomerInvoiceList extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);

    const { priceMasking } = props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

    this.state = {
      currentPage: 1,
      startDate: dayjs().valueOf(),
      openSelectedDuration: dayjs().subtract(300, 'd').valueOf(),
      closedSelectedDuration: 'LAST 60 DAYS',
      tableColumns: [
        {
          title: '',
          render: (record) => (
            <Link to={`/sales/invoice/view/${record?.invoice_id}`}>
              <div className="mobile-list__item">
                <div style={{ display: 'flex' }}>
                  <H3Text text={`#${record?.invoice_number}`} className="mobile-list__item-number" />
                  <div className="mobile-list__item-status" style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}>
                    {Helpers.getStatusColor(record.status).text?.toUpperCase()}
                  </div>
                </div>
                { record?.customer_info && (
                  <div className="mobile-list__item-info">
                    {`Customer - ${record?.customer_info?.customer_name}`}
                  </div>
                )}
                {record?.order_id && <H3Text text={`Order Number - ${record?.sales_order_number}`} className="mobile-list__item-info" />}
                <H3Text text={`Invoice Total - ${this.props.MONEY(record?.invoice_grand_total || '0')}`} className="mobile-list__item-info" />
                <H3Text text={`Created by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer" />
              </div>
            </Link>
          ),
          responsive: ['xs'],
        },
        {
          title: 'INVOICE NUMBER',
          dataIndex: 'invoice_number',
          responsive: ['sm', 'md', 'lg', 'xxl'],

        },
        {
          title: 'SO NUMBER',
          responsive: ['sm', 'md', 'lg', 'xxl'],

          render: (text, record) => (
            <div>
              <div className="company__name" style={{ fontWeight: '600' }}>
                {record?.order_id ? (
                  <Link to={`/sales/sales-order/view/${record?.order_id}`} target="_blank">
                    {record?.sales_order_number}
                  </Link>
                ) : '-' }

              </div>
            </div>
          ),
        },
        {
          title: 'ITEMS',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (item) => item?.invoice_lines?.filter((invoice) => invoice.status !== 'CANCELLED').length,
        },
        {
          title: 'DATE',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (record) => (
            <div>
              {dayjs(record?.invoice_date).format('DD/MM/YYYY')}
              <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
            </div>
          ),
        },
        {
          title: 'INVOICE AMOUNT',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (item, record) => ((isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view invoice amount"} /> : this.props.MONEY(record?.invoice_grand_total, record?.org_currency_info?.currency_code)),
        },
        {
          title: 'DUE DATE',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (record) => (
            <Fragment>
              <div style={{ whiteSpace: 'nowrap' }}>
                { record?.invoice_due_date ? toISTDate(record?.invoice_due_date).format('DD/MM/YYYY') : '-'}
                {' '}
              </div>
            </Fragment>
          ),
        },
        {
          title: 'STATUS',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (item) => (
            <Fragment>
              <div style={{ display: 'flex' }}>
                <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(item.status).color }}>
                  { Helpers.getStatusColor(item.status).text}
                </div>
              </div>
            </Fragment>
          ),
        },
        {
          title: '',
          key: 'action',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          fixed: 'right',
          render: (record) => {
            const { history, user } = this.props;
            return (
              <div style={{
                textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
              }}
              >
                {Helpers.getPermission(Helpers.permissionEntities.INVOICE,
                  Helpers.permissionTypes.UPDATE, user) && (
                  <div
                    className="roundIconButton"
                    onClick={() => {
                      history.push(`/sales/invoices/update/${record?.invoice_id}`);
                    }}
                  >
                    <EditOutlined />
                  </div>
                )}
                <div
                  className="customer-invoice-view-button"
                  onClick={() => {
                    history.push(`/sales/invoice/view/${record?.invoice_id}`);
                  }}
                >
                  View
                </div>
              </div>
            );
          },
        },
      ],
      showNewCustomerModal: false,
      showUpdateCustomerModal: false,
      searchKeyword: '',
      mobileVendorsLength: 10,
    };
  }

  /**
   *
   */
  componentDidMount() {
    const { getInvoiceSuccess } = this.props;
    getInvoiceSuccess(null);
  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    const { customerId } = props.match.params;

    if (props.user && !state.isUserReady) {
      const { currentPage } = state;
      const { getInvoice, user } = props;
      getInvoice(user?.tenant_info?.org_id, user?.tenant_info?.tenant_id, '', currentPage, 10, customerId);
      return {
        ...state,
        isUserReady: true,
      };
    }
    return state;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      invoices, getInvoiceLoading, user, getInvoice, match,
    } = this.props;
    const {
      currentPage, tableColumns, searchKeyword, keyword,
    } = this.state;
    const { customerId } = match.params;
    return (
      <Fragment>
        <div className="customer-invoices__wrapper">
          <div className="ant-row">
            <div className="ant-col-xs-24">
              <div className="customer-invoices__table__wrapper">
                {searchKeyword && searchKeyword.length > 0 && (
                  <div className="search-bar__search-container__clear-button">
                    <H3Text
                      text={(
                        <React.Fragment>
                          Showing search results for&nbsp;
                          <i>
                            <b>
                              {`'${searchKeyword}'`}
                            </b>
                          </i>
                        </React.Fragment>
                      )}
                      className="section-search-keyword"
                    />
                    <H3Text
                      text="clear"
                      className="search-bar__clear-button"
                      onClick={() => {
                        this.setState({ searchKeyword: '', keyword: '', currentPage: 1 });
                        getInvoice(user?.tenant_info?.tenant_id, '', 1, 10, customerId);
                      }}
                    />
                  </div>
                )}
                <div className="customer-invoices__table__data">
                  <Table
                    title={() => `${(invoices && invoices?.data.count) ? invoices?.data?.count : '0'} Total Invoices`}
                    loading={getInvoiceLoading}
                    showHeader
                    size="small"
                    scroll="scroll"
                    columns={tableColumns}
                    dataSource={invoices && (invoices?.data?.invoices ? invoices?.data?.invoices : [])}
                    pagination={invoices?.data?.count > 10 ? {
                      defaultCurrent: 1,
                      current: currentPage,
                      total: invoices ? invoices?.data?.count : 0,
                      pageSize: 10,
                      onChange: (page) => {
                        this.setState({ currentPage: page });
                        getInvoice(user?.tenant_info?.org_id, user?.tenant_info?.tenant_id, keyword, page, 10, customerId, null, null, null, null, null, true);
                      },
                      position: ['bottomRight'],
                      showSizeChanger: false,
                    } : false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, InvoiceReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getInvoiceLoading: InvoiceReducers.getInvoiceLoading,
  invoices: InvoiceReducers.invoices,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getInvoice: (orgId, tenantId, invoiceId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, listScreen,) => dispatch(InvoiceActions.getInvoice(orgId, tenantId, invoiceId, page, limit, customerId,searchKeyword, status, startDate, endDate, departmentId, listScreen)),
  getInvoiceSuccess: (invoices) => dispatch(InvoiceActions.getInvoiceSuccess(invoices)),

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomerInvoiceList));
